<template>
  <div class="contact-form">
    <label>{{ $t('root.filters.operator') }}</label>
    <select v-model='predicate'>
      <option :value='true'>{{ $t('root.filters.true') }}</option>
      <option :value='false'>{{ $t('root.filters.false') }}</option>
    </select>

    <label>{{ $t('root.filters.uploaded_from') }}</label>
    <multi-select v-model='selected' :options='options' />

    <div class="float-right">
      <button class="btn-sm btn btn-neutral m-r-10" @click.prevent="$emit('cancel')">{{ $t('root.filters.cancel') }}</button>
      <button class="btn-sm btn btn-primary" @click.prevent='filter'>{{ $t('root.filters.apply') }}</button>
    </div>
  </div>
</template>

<script>
  import _multi_select from '../../_multi_select'

  export default {
    components: {
      'multi-select': _multi_select,
    },
    props: {
      folder: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        predicate: true,
        selected: [],
      }
    },
    computed: {
      options() {
        return [
          { name: this.$t('root.filters.app'), id: 'app' },
          { name: this.$t('root.filters.email'), id: 'email' },
          { name: this.$t('root.filters.public_page'), id: 'public_page' },
        ]
      },
      selectedIds() {
        return this.selected.map(x => x.id)
      },
      predicateQuery() {
        return this.predicate ? 'filters[uploaded_from_in]' : 'filters[uploaded_from_not_in]'
      }
    },
    methods: {
      filter() {
        let newQuery = Object.assign({}, this.query)

        delete newQuery['filters[uploaded_from_in]']
        delete newQuery['filters[uploaded_from_not_in]']

        newQuery = Object.assign({}, newQuery, { page: 1, parent_id: this.folder.id, [this.predicateQuery]: this.selectedIds })
        this.$router.push({ query: newQuery })
      },
    }
  }
</script>

<style lang="sass" scoped>
.contact-form
  width: 325px
  padding: 10px
  select
    margin-bottom: 15px
  .custom-select
    margin-bottom: 15px
.form-inline
  label
    margin-right: 10px
    &:first-child
      margin-right: 15px
  input
    margin-left: 3px
</style>
